// react-select styled with design-system tokens, for the search / multi-select controls
// that the native src/ui Select doesn't cover. Shared by Add Student and Add Teacher.
import type { GroupBase, StylesConfig } from 'react-select';
import './dsReactSelect.scss';

/** classNamePrefix to pass with these styles; dsReactSelect.scss resets the template's input styling. */
export const DS_SELECT_PREFIX = 'ds-rs';

export function dsSelectStyles<Option, IsMulti extends boolean = false>(): StylesConfig<
  Option,
  IsMulti,
  GroupBase<Option>
> {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: 'var(--ds-control-md)',
      borderRadius: 'var(--ds-radius-sm)',
      borderColor: state.isFocused ? 'var(--ds-primary)' : 'var(--ds-border-strong)',
      boxShadow: state.isFocused ? 'var(--ds-focus-ring)' : 'none',
      background: state.isDisabled ? 'var(--ds-surface-muted)' : 'var(--ds-surface)',
      fontFamily: 'var(--ds-font)',
      fontSize: 14,
      '&:hover': { borderColor: state.isFocused ? 'var(--ds-primary)' : 'var(--ds-text-subtle)' },
    }),
    valueContainer: (base) => ({ ...base, padding: '0 var(--ds-space-6)' }),
    input: (base) => ({ ...base, margin: 0, padding: 0, color: 'var(--ds-text)' }),
    singleValue: (base) => ({ ...base, margin: 0, color: 'var(--ds-text)' }),
    placeholder: (base) => ({ ...base, color: 'var(--ds-text-subtle)' }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, color: 'var(--ds-text-muted)' }),
    clearIndicator: (base) => ({ ...base, color: 'var(--ds-text-subtle)' }),
    multiValue: (base) => ({
      ...base,
      background: 'var(--ds-primary-soft)',
      borderRadius: 'var(--ds-radius-full)',
    }),
    multiValueLabel: (base) => ({ ...base, color: 'var(--ds-primary)', fontWeight: 600 }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'var(--ds-primary)',
      borderRadius: 'var(--ds-radius-full)',
      '&:hover': { background: 'var(--ds-primary-soft)', color: 'var(--ds-primary-hover)' },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: 'var(--ds-radius-sm)',
      boxShadow: 'var(--ds-shadow-lift)',
      border: '1px solid var(--ds-border)',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      fontSize: 14,
      color: state.isSelected ? 'var(--ds-text-on-dark)' : 'var(--ds-text)',
      background: state.isSelected
        ? 'var(--ds-primary)'
        : state.isFocused
          ? 'var(--ds-primary-soft)'
          : 'transparent',
    }),
  };
}
